import firebase from "firebase/app";
import localforage from "localforage";
import "firebase/messaging";
import app from './app';
import api from './api';
import store from './store';


const messages = {
	fm: null,
	timer: null,
	init(){
		const $this = this;

		if(app.$route.query != undefined && app.$route.query.p1 != undefined){
			let obj = { action: app.$route.query.p1, target: undefined };
			if(app.$route.query.p2 != undefined && app.$route.query.p2 != "/")
				obj.target = app.$route.query.p2;

			// clara query string
			let query = Object.assign({}, app.$route.query);
			delete query.p1;
			if(app.$route.query.p2 != undefined) delete query.p2;
			app.$router.replace({ query });

			// take action
            this.action(obj);
        }

		if(window.safari != undefined){
			let safari = window.safari.pushNotification.permission("web.com.adbalu");
			if(safari.permission == "default"){
				app.$root.$bvModal.msgBoxOk(app.$t('home.firebase_messaging_text'), {
	                title: app.$t('home.firebase_messaging_title'),
	                size: 'sm',
	                buttonSize: 'lg',
	                okTitle: app.$t('base.btn_ok'),
	                modalClass: 'confirmModal',
	                hideHeaderClose: false,
	                centered: true
	            }).then(() => {
	                store.dispatch('sound/sfx','Button');
	            	$this.safariInit();
	            });
			}
			else if(safari.permission == "granted"){
				$this.safariInit();
			}
		}

		// stop if not suported
		if(!firebase.messaging.isSupported()) return;

		localforage.config({
		    name        : 'adbalu',
		    version     : 1.0,
		    storeName   : 'adbalu_notifications',
		});

		// read all notifications on page start
		this.readFromDb();

		document.addEventListener("visibilitychange", function() {
			if(document.hidden || $this.timer != null) clearTimeout($this.timer);
		  	if(document.hidden == false) $this.timer = setTimeout(() => { $this.readFromDb(); $this.timer = null; }, 500);
		});

		// console.log(Notification.permission);
		// check permissions
		if('Notification' in window && Notification.permission == "default"){
			app.$root.$bvModal.msgBoxOk(app.$t('home.firebase_messaging_text'), {
                title: app.$t('home.firebase_messaging_title'),
                size: 'sm',
                buttonSize: 'lg',
                okTitle: app.$t('base.btn_ok'),
                modalClass: 'confirmModal',
                hideHeaderClose: false,
                centered: true
            }).then(() => {
            	store.dispatch('sound/sfx','Button');
            	$this.fInit();
            });
		}
		else if('Notification' in window && Notification.permission == "granted"){
			$this.fInit();
		}
	},

	fInit(){
		// stop if not suported
		if(!firebase.messaging.isSupported()) return;

		const $this = this;
		
		// Retrieve Firebase Messaging object.
		this.fm = firebase.messaging();

		// Get registration token. Initially this makes a network call, once retrieved
		// subsequent calls to getToken will return from cache.
		this.fm.getToken({vapidKey: 'BAzttn5K9iieNX8wkxFRKaRiiPxDae4dRez73EAFo1eFWmwWUVhPYsV8r8fdw-yfM5lj1_tOXmsEcoQ8mVv_UhY'}).then((currentToken) => {
			if (currentToken) {
				if(localStorage.getItem("nToken") != currentToken){
					api.updateNotificationToken(currentToken, "web")
					.then(response => {
						// console.log("Notification token is updated", currentToken);
						console.log("Notification token is updated");
						localStorage.setItem("nToken", currentToken);
					})
					.catch(error => {
						console.log("Notification token not updated", error);
					});
				}
			} 
			else {
				// Show permission request.
				console.log('No registration token available. Request permission to generate one.');
			}
		}).catch((err) => {
			console.log('An error occurred while retrieving token. ', err);
		});


		this.fm.onMessage((payload) => {
			// console.log('Message received. ', payload);
			$this.showMessage(payload.data);
		});

		// navigator.serviceWorker.addEventListener('message', function(event) {
		// 	console.log('Message received (service worker): ', event.data);
		// 	if(event.data.action != undefined) $this.showMessage(event.data);
		// });
	},

	safariInit(){
		const $this = this;

		let s = window.safari.pushNotification.permission("web.com.adbalu");

		if(s.permission == "granted"){
			if(localStorage.getItem("nToken") != s.deviceToken){
				api.updateNotificationToken(s.deviceToken, "safari")
					.then(response => {
						// console.log("Notification token is updated", currentToken);
						console.log("Notification token is updated");
						localStorage.setItem("nToken", s.deviceToken);
					})
					.catch(error => {
						console.log("Notification token not updated", error);
					});
			}
		}
		else{
			// console.log("safariInit else", s);
			// let user = app.$store.state.auth.user;
			// console.log(user);
			window.safari.pushNotification.requestPermission(
				"https://adbalu.mobi/push",
				"web.com.adbalu",
				{},
				(res) => {
					if(res.deviceToken){
						api.updateNotificationToken(res.deviceToken, "safari")
						.then(response => {
							// console.log("Notification token is updated", currentToken);
							console.log("Notification token is updated");
							localStorage.setItem("nToken", res.deviceToken);
						})
						.catch(error => {
							console.log("Notification token not updated", error);
						});
					}
				}
			);
		}

	},

	readFromDb(){
		const $this = this;

		const allMessages = [];
		localforage.iterate(function(value, key, iterationNumber) {
			// write to array
		    allMessages.push(value);

		}).then(function() {
		    
		    console.log('iterate notifications finish');
		    // console.log(allMessages);

		    localforage.clear(); // clear db, optional
		    // sort messages by time
		    allMessages.sort((a, b) => (a.time > b.time) ? 1 : -1);
		    // limit to last 10 messags
		    allMessages.length = Math.min(allMessages.length, 5);

		    // console.log(allMessages);

		    // render all messages
		    for(let m in allMessages)
		    	$this.showMessage(allMessages[m]); 

		}).catch(function(err) {
		    // This code runs if there were any errors
		    //console.log(err);
		});
	},

	showMessage(data){
		const $this = this;
		// remove from db
		localforage.removeItem(data.action);

		if (data.action == "TEAM_MESSAGE" && document.querySelector("#teamChatPage .chat-list-holder") != undefined)
            return;

		store.dispatch('sound/sfx','Message');

		let text = "<h4 class=\"mb-4\">"+data.title+"</h4><div>"+data.body+"</div>";
		app.$root.$bvModal.msgBoxConfirm(this.htmlToVNode(text), {
            title: app.$t('home.firebase_messaging_popup_title'),
            size: 'sm',
            buttonSize: 'lg',
            okTitle: app.$t('base.btn_ok'),
            cancelTitle: app.$t('base.btn_cancel'),
            modalClass: 'confirmModal',
            hideHeaderClose: false,
            centered: true,
        })
        .then(value => {
            if(value){
                $this.action(data);
            }
        })
        .then(value => {
        	store.dispatch('sound/sfx','Button');
        })
	},

	action(data){
		if(["TRIVIA_QUIZ_PARTICIPATION_FIRST_INVITATION","TRIVIA_QUIZ_PARTICIPATION_SECOND_INVITATION","TRIVIA_QUIZ_START","TRIVIA_QUIZ_STARTING","SHOW_QUIZ"].includes(data.action)){
        	app.$emit("setHomeView", { view: "triviaquiz" });
        }
		else if(["SHOW_SUPER_CHALLENGE"].includes(data.action)){
        	app.$emit("setHomeView", { view: "super-challenge", target: 1 }); // tab 1
        }
        else if(["CHEQUE_PAYMENT_ERROR_STATUS","CHEQUE_PAYMENT_PROCESSING_STATUS","CHEQUE_PAYMENT_REFUNDED_STATUS","VOUCHER_PAYMENT_ERROR_STATUS","VOUCHER_PAYMENT_PROCESSING_STATUS","VOUCHER_PAYMENT_REFUNDED_STATUS","SHOW_PROFILE","SHOW_PROFILE_ACTIVE_AWARDS"].includes(data.action)){
        	app.$emit("setHomeView", { view: "profile" }); // tab 0
        }
        else if(["SHOW_PROFILE_REFUNDED_AWARDS"].includes(data.action)){
        	app.$emit("setHomeView", { view: "profile" }); // tab 1
        }
        else if(["USER_INACTIVITY","SHOW_HOME"].includes(data.action)){
        	app.$emit("setHomeView", { view: "AD_QUIZZES" });
        }
        else if(["REFERRAL_SUPPORT","REFERRAL_PROFIT","SHOW_REFERRALS","SHOW_REFERRALS_RECENT"].includes(data.action)){
        	app.$emit("setHomeView", { view: "referral-tab" }); // tab 0
        }
        else if(["SHOW_REFERRALS_ALLTIME"].includes(data.action)){
        	app.$emit("setHomeView", { view: "referral-tab", target: 1 }); // tab 1
        }
        else if(["NEWS","SHOW_NEWS"].includes(data.action)){
        	app.$emit("setHomeView", { view: "news", target: data.target });
        }
        else if(["SHOW_SHOP"].includes(data.action)){
        	app.$emit("setHomeView", { view: "shop-tab" });
        }
        else if(["SHOW_URL"].includes(data.action)){
        	window.location = data.target;
        }
        else if(["CHALLENGE_TIE","CHALLENGE_WON","CHALLENGE_LOST"].includes(data.action)){
        	app.$emit("setHomeView", { view: "challenge-results", target: data.target });
        }
        else if(["SHOW_CHALLENGES","CHALLENGE_FAILURE"].includes(data.action)){
        	app.$emit("setHomeView", { view: "challenge", target: 0 });
        }
		else if(["TEAM_REQUEST_APPROVAL","TEAM_REQUEST_CREATION","TEAM_INVITATION_ACCEPTANCE","TEAM_LEAVING","TEAM_KICKING","TEAM_DELETION","TEAM_DELETION"].includes(data.action)){
        	app.$emit("setHomeView", { view: "team-tab" });
        }
		else if(["TEAM_REQUEST_APPROVAL","TEAM_REQUEST_CREATION","TEAM_INVITATION_ACCEPTANCE","TEAM_LEAVING","TEAM_KICKING","TEAM_DELETION","TEAM_DELETION"].includes(data.action)){
        	app.$emit("setHomeView", { view: "team-tab" });
        }
		else if(["TEAM_MESSAGE"].includes(data.action)){
        	app.$emit("openTeamChat");
        }
        else if(["AUCTION_START","AUCTION_REMINDER","AUCTION_OUTBID","AUCTION_WINNER","AUCTION_PAYMENT_AWARDED_STATUS","AUCTION_PAYMENT_ERROR_STATUS"].includes(data.action)){
        	app.$emit("setHomeView", { view: 'auction-info', target: data.target});
        }
		else if(["FAMILY_LEAVING","FAMILY_KICKING","FAMILY_INVITATION","FAMILY_INVITATION_ACCEPTANCE","FAMILY_DELETION"].includes(data.action)){
        	app.$emit("setHomeView", { view: "profile" });
        }

        // else if(["SHOW_APP_RATE"].includes(data.action)){
        // 	app.$emit("setHomeView", "shop-tab");
        // }	
	},

	deleteToken(){
		// stop if not suported
		if(!firebase.messaging.isSupported()) return;
		this.fm.deleteToken();
	},

	htmlToVNode(html) {
        return [
            app.$createElement('div', { domProps: { innerHTML: html } })
        ]
    }
}

export default messages